module.exports = __webpack_public_path__ + "static/media/empty-cards.b9d1c320.svg";